import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as Showdown from 'showdown';

import {Language} from 'classes/language';
import {Content, ContentQuestionaire} from 'shared/models/contents/content';
import {TranslatedText} from 'shared/models/translated-text';
import {ContentsDetailsService} from './services/contents-details.service';
import { TargetGroup, TARGETGROUP_DUMMIES } from 'shared/models/target-groups/target-group';

import {ContentDatepickerComponent} from './content-datepicker/content-datepicker.component';
import content from '*.json';
import { Subscription } from 'rxjs/Subscription';
import { Dialog } from 'shared/classes/dialog';
import { DragulaService } from 'ng2-dragula';
import { ContentItem } from 'shared/models/contents/content-item';

@Component({
  selector: 'contents-details',
  templateUrl: './contents-details.component.html',
  styleUrls: ['./contents-details.component.css'],
})
export class ContentsDetailsComponent implements OnInit {

  @ViewChild('startDatepicker') public startDatepicker: ContentDatepickerComponent;
  @ViewChild('endDatepicker') public endDatepicker: ContentDatepickerComponent;

  public languages: Array<Language> = Language.defaultLanguages;
  public language: string = this.languages[0].code;
  public content: Content = {
    title: TranslatedText.createEmptyInstance(),
    description: TranslatedText.createEmptyInstance(),
    keywords: TranslatedText.createEmptyInstance(),
    precond: [],
    notparallel: [],
    active: true,
    pausable: false,
    autostart: false,
    daily: false,
    weekend: false,
    leadersOnly: false,
    sequential: false,
    skipable: false,
    omnibus: false,
    targetGroups: [],
    targetGroupsPurchasable: [],
    startDate: undefined,
    endDate: undefined,
    orderno: undefined,
    items: [],
    grades: [],
    suggests: []
  };
  public errorText: string = null;
  
  public showMarkdownOutput: boolean = false;
  private markdownOutput: {
    de: string,
    en: string,
  };
  private converter: Showdown.Converter = new Showdown.Converter();

  public allContents: Dictionary<Content> = {};

  public selectedPrecond: string = '';
  public selectablePrecond: Array<string> = [];

  public selectedNotparallel: string = '';
  public selectableNotparallel: Array<string> = [];

  public allTargetGroups: Array<TargetGroup> = [];

  public selectedTargetGroup: TargetGroup;
  public selectableTargetGroups: Array<TargetGroup> = [];

  public selectedTargetGroupPurchasable: TargetGroup;

  public dayTarget: Array<Array<Dialog>> = [[],[],[],[],[],[],[],];

  private dialogs: Array<Dialog> = [];
  public searchTerm: string;

  public availableDialogs:Array<Dialog> = [];
  subs = new Subscription();

  public countWeeks : number = 0;
  public filteredDialogs2 = [];

  public allSuggestDialogs: Array<Dialog> = [];
  public isAddingSuggest: boolean = false;

  public isQuestionaire = false;
  public isFilterDialogsQuestionaire = false;

  constructor(private contentsDetailsService: ContentsDetailsService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private dragulaService: DragulaService) {
    this.converter.setFlavor('github')

    this.subs.add(this.dragulaService.drop
      .subscribe(({ name, el, target, source, sibling }) => {
        console.log("drop %o %o %o %o %o", name, el, target, source, sibling);
        setTimeout(() => { this.calcCountWeeks() }, 0);
      })
    );
    try {
      this.dragulaService.setOptions("dialog-bag", {copy: function(a, b, c, d) {
//        console.log("copa %o", b.attributes['id']);
//        console.log("copx " + (b.attributes['id'] && b.attributes['id'].value == 'dialogAccordion') );
        return (b.attributes['id'] && b.attributes['id'].value == 'dialogAccordion');
      }});
    }
    catch (err) { // nicht Standard
      console.log("Err %o", err);
    }
  }

  public ngOnInit(): void {
    this.getAllContents();
    this.getAllTargetGroups();
    this.markdownOutput = {de: '', en: ''};
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['contentId'];
    })
      .subscribe((contentId: string) => {
        if (contentId) {
          this.getContent(contentId);
        }
      });
    this.activatedRoute.params.map((urlParameters: Params) => {
      return urlParameters['orderno'];
    })
      .subscribe((orderno: number) => {
          this.content.orderno = orderno;
      });

      this.contentsDetailsService.getDialogs()
      .subscribe((dialogs: Array<Dialog>) => {
        this.dialogs = dialogs;
        this.availableDialogs = dialogs;
        this.applyItems();
        this.allSuggestDialogs = dialogs.filter(dialog => dialog.contSuggest);
      });

  }

  ngOnDestroy() {
    // destroy all the subscriptions at once
    this.subs.unsubscribe();
  }

  public onSubmit(): boolean {
    this.content.items = this.collectItems();
    if ( this.content.grades !== undefined ) {
      const maxPoints = this.sumPointsAll(); 
      for (let i = 0; i < this.content.grades.length; i++) {
        if ( this.content.grades[i].points > maxPoints) {
          this.errorText = "Punkte einer Zertifikatsstufe übersteigen die maximal erreichbare Punktzahl.";
          return false;
        }
      }
    }

    if (this.content._id) {
      this.updateContent();
    } else {
      this.saveContent();
    }
    return true;
  }

  private getContent(id: string): void {
    this.contentsDetailsService.getContent(id)
      .subscribe((content: Content) => {
        this.content = content;
        this.updateMarkdown();
        this.startDatepicker.updateUtcDate(content.startDate);
        this.endDatepicker.updateUtcDate(content.endDate);
        this.selectablePrecond = Object.keys(this.allContents).filter(key => content.precond.indexOf(key) == -1 && key != content._id);
        this.selectableNotparallel = Object.keys(this.allContents).filter(key => content.notparallel.indexOf(key) == -1 && key != content._id);
        if (!content.targetGroups) {
          content.targetGroups = [];
        }
        if (!content.targetGroupsPurchasable) {
          content.targetGroupsPurchasable = [];
        }
        this.selectableTargetGroups = this.allTargetGroups.filter(group => content.targetGroups.filter(group1 => group1._id == group._id).length == 0);
        this.selectableTargetGroups = this.selectableTargetGroups.filter(group => content.targetGroupsPurchasable.filter(group1 => group1._id == group._id).length == 0);
        if (this.dialogs.length > 0) {
          this.applyItems();
        }
        if (!content.keywords) {
          content.keywords = TranslatedText.createEmptyInstance();
        }
        this.isQuestionaire = (content.questionaire !== undefined && content.questionaire !== null);
      });
  }

  private getAllContents(): void {
    this.contentsDetailsService.getContents()
      .subscribe((contents: Array<Content>) => {
        this.allContents = {};
        this.selectablePrecond = [];
        contents.forEach(content => {
          this.allContents[content._id] = content;
          this.selectablePrecond.push(content._id);
          this.selectableNotparallel.push(content._id);
        });
      });
  }

  private getAllTargetGroups(): void {
    this.contentsDetailsService.getAllTargetGroups()
    .subscribe((allTargetGroups) => {
      this.allTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
      this.selectableTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
    });
  }

  private getDialogById(id: string): Dialog {
    return this.dialogs.find(dialog => dialog._id == id);
  }

  private saveContent(): void {
    // this.errorText = this.content.type.validate();
    if (this.errorText != null) {
      return;
    }
    this.contentsDetailsService.saveContent(this.content)
      .subscribe((content: Content) => {
        this.router.navigateByUrl('/contents');
      });
  }

  private updateContent(): void {
    //this.errorText = this.content.type.validate();
    if (this.errorText != null) {
      return;
    }
    this.contentsDetailsService.updateContent(this.content)
      .subscribe((content: Content) => {
        this.router.navigateByUrl('/contents');
      });
  }

  public setLanguage(language: Language): void {
    this.language = language.code;
  }

  public get caption(): string {
    return this.content._id ? 'Themenpaket bearbeiten' : 'Themenpaket erstellen';
  }

  public get submitButtonText(): string {
    return this.content._id ? 'Speichern' : 'Erstellen';
  }

  private setMarkdownOutput(value: boolean): void {
    this.showMarkdownOutput = value;
  }

  private updateMarkdown(): void {
    this.markdownOutput[this.language] = this.converter.makeHtml(this.content.description[this.language]);
  }

  public selectPrecond(id: string): void {
    if (id !== '') {
      this.content.precond.push(id);
      this.selectablePrecond.splice(this.selectablePrecond.indexOf(id), 1);
    }
  }

  public deselectPrecond(id: string): void {
    this.selectablePrecond.push(id);
    this.content.precond.splice(this.content.precond.indexOf(id), 1);
  }

  public selectNotparallel(id: string): void {
    if (id !== '') {
      this.content.notparallel.push(id);
      this.selectableNotparallel.splice(this.selectableNotparallel.indexOf(id), 1);
    }
  }

  public deselectNotparallel(id: string): void {
    this.selectableNotparallel.push(id);
    this.content.notparallel.splice(this.content.notparallel.indexOf(id), 1);
  }

  public selectTargetGroup(group: TargetGroup): void {
    if (this.isTargetGroup(group)) {
      this.content.targetGroups.push(group);
      this.selectableTargetGroups.splice(this.selectableTargetGroups.indexOf(group), 1);
    }
  }

  public deselectTargetGroup(group: TargetGroup): void {
    this.selectableTargetGroups.push(group);
    this.content.targetGroups.splice(this.content.targetGroups.indexOf(group), 1);
  }

  public selectTargetGroupPurchasable(group: TargetGroup): void {
    if (this.isTargetGroup(group)) {
      this.content.targetGroupsPurchasable.push(group);
      this.selectableTargetGroups.splice(this.selectableTargetGroups.indexOf(group), 1);
    }
  }

  public deselectTargetGroupPurchasable(group: TargetGroup): void {
    this.selectableTargetGroups.push(group);
    this.content.targetGroupsPurchasable.splice(this.content.targetGroupsPurchasable.indexOf(group), 1);
  }

  private isTargetGroup(obj: any): obj is TargetGroup {
    return obj._id !== undefined
  }


  public handleStartDateChange(date: Date): void {
    this.content.startDate = date;

    // Don't allow start date to be after the end date
    if (this.endDatepicker.utcDate < this.startDatepicker.utcDate) {
      this.endDatepicker.utcDate = new Date(this.startDatepicker.utcDate.getTime());
      this.content.endDate = new Date(this.content.startDate.getTime());
    }
  }

  public handleEndDateChange(date: Date): void { // tslint:disable-line
    this.content.endDate = date;
  }

  public calcCountWeeks(): void {
    let weeks = 0;
    this.dayTarget.forEach((dialogs, index) => {
      if (dialogs.length > 0) {
        let week = Math.floor(index / 7);
        if (week+1 > weeks) {
          weeks = week+1;
        }
      }
    });
    for (let i = 0; i < 7*(weeks+1); i++) {
      if (this.dayTarget[i] === undefined) {
        this.dayTarget[i] = [];
      }
    }
    this.countWeeks = weeks;
  }

  private applyItems(): void {
    if (this.content.items === undefined) {
      this.content.items = [];
    }
    this.dayTarget = [];
    this.content.items.forEach(item => {
      if (this.dayTarget[item.day] === undefined) {
        this.dayTarget[item.day] = [];
      }
      this.dayTarget[item.day].push(this.getDialogById(item.dialog));
    });
    this.calcCountWeeks();
  }

  private collectItems(): Array<ContentItem> {
    const items = [];
    this.dayTarget.forEach((dialogs, day) => {
      dialogs.forEach(dialog => {
        let dia = {dialog: dialog._id, day: day};
        let itemPoints = this.content.items.find(d => d.dialog == dialog._id);
        if ( itemPoints != undefined && itemPoints.points != undefined ) {
          dia['points'] = itemPoints.points;
        }
        items.push(dia);
      })
    });
    return items;
  }

  // dialog list
  public get filteredDialogs(): Array<Dialog> {
    const filtered = this.dialogs.filter((dialog) => {
      return this.filterBySearchTerm(dialog);
    });
    filtered.sort(((a, b) => a.title[this.language].localeCompare(b.title[this.language])));
    this.filteredDialogs2 = filtered;
    return filtered;
  }

  private filterBySearchTerm(dialog: Dialog): boolean {
    if ( this.isQuestionaire && this.isFilterDialogsQuestionaire ) {
      if ( dialog.questions.find(question => question.varName !== undefined && question.varName !== null) === undefined) {
        return false;
      }
    }

    if (!this.searchTerm) {
      return true;
    }

    const searchTerm: string = this.searchTerm.toLowerCase();

    if (dialog.title[this.language].toLowerCase().includes(searchTerm)) {
      return true;
    }

    if (dialog.description[this.language].toLowerCase().includes(searchTerm)) {
      return true;
    }

    return false;
  }

  public createDialog() {
    alert("Not yet implemented.");
  }

  public getDialogTime(dialog: Dialog): string {
    if ( !dialog || dialog.startDate === undefined || dialog.startDate === null) {
      return "--:--"
    }

    const timeStartIndex: number = 11;
    const timeLength: number = 5;

    if (dialog.startDate instanceof Date) {

      const pipedTime: string = dialog.startDate .toISOString().substr(timeStartIndex, timeLength);
      return pipedTime;
    }

    const s = dialog.startDate+'';
    if (s.indexOf('T') == 10) {
      return s.substr(timeStartIndex, timeLength);
    }
    return '??:??';
  }

  public isDialogWithSolution(dialog: Dialog): boolean {
    return dialog.questions.find(q => q.solution) !== undefined;
  }

  // Suggest

  public addSuggest(): void {
    this.isAddingSuggest = true;
  }

  public addSuggestDialog(sgDialog: Dialog): void {
    console.log(sgDialog);
    if ( this.content.suggests === undefined) {
      this.content.suggests = [];
    }
    this.content.suggests.push({
      dialog: sgDialog._id,
      points: sgDialog.questions.map(q => 0),
    });
    this.isAddingSuggest = false;
  }

  public deleteSuggest(i: number) {
    this.content.suggests.splice(i, 1);
  }

  public getSgDialog(id: string): Dialog {
    return this.allSuggestDialogs.find(d => d._id == id);
  }

  public sumPoints(points: Array<number>): number {
    if ( points === undefined ) {
      return 0;
    }
    return  points.reduce((a, b) => a + b, 0);
  }

  // Grades

  public getContentItemsWithSolutionIds(): Array<number> {
    const arr = [];
    for (let i = 0; i < this.content.items.length; i++) {
      const dia = this.getDialogById(this.content.items[i].dialog);
      const res = (dia !== undefined && dia.questions !== undefined && dia.questions.find(q => q.solution) !== undefined);
      if ( res && (this.content.items[i].points === undefined) ) {
        this.content.items[i].points = dia.questions.map(q => 0); 
      }
      if ( res ) {
        arr.push(i);
      }
    };
    return arr;
  }

  public sumPointsAll() {
    return this.content.items
      .filter(item => item.points)
      .map(item => item.points.reduce((a, b) => a + b, 0))
      .reduce((a, b) => a + b, 0);
  }

  public addGrade() {
    if ( this.content.grades == undefined ) {
      this.content.grades = [];
    }
    this.content.grades.push({title: {de: '', en: ''}, points: 0}); 
  }

  public deleteGrade(i: number) {
    this.content.grades.splice(i, 1);
  }

  public sortGrades() {
    if ( this.content.grades != undefined ) {
      this.content.grades = this.content.grades.sort((a, b) => b.points - a.points);
    }
  }

  // Questionaire

  public getQuestionaire(): ContentQuestionaire {
    if ( this.isQuestionaire ) {
      if ( !this.content.questionaire ) {
        this.content.questionaire = {vars: [{type: 'simple', name: "", value:""}], textMappings:[]}; 
      }
      return this.content.questionaire;
    }
    return undefined;
  }

  public deleteQuestionaireVar(i: number): void {
    this.content.questionaire.vars.splice(i, 1);
  }

  public addQuestonaireVar(): void {
    this.content.questionaire.vars.push({type: 'simple', name: "", value:""});
  }

  public moveQuestionaireVar(i: number, direction: number) {
    const varEntry = this.content.questionaire.vars.splice(i, 1);
    this.content.questionaire.vars.splice(i+direction, 0, varEntry[0]);
  }

  private getVarsFromDialogs(): Array<string> {
    return this.content.items.map(item => (this.getDialogById(item.dialog)?.questions || [])
      .filter(question => question.varName != undefined && question.varName !== null) 
      .map(question=> question.varName))
      .reduce(function (flattenedArray, element) {
        return flattenedArray.concat(element);
      }, []);
  }

  public getDialogVarsHintQuestionaire(): string {
    return "Variablen aus den Dialogen:\r\n"+this.getVarsFromDialogs().join(", ");
  }
  
  public varErrorQuestionaire(i: number) {
    let vars = this.getVarsFromDialogs();
    vars = vars.concat(this.content.questionaire.vars.slice(0, i).map(verEntry => verEntry.name));
    let s = this.content.questionaire.vars[i].value;
    vars.forEach(var1 => s = s.replace(new RegExp('\\b' + var1 + '\\b', "g"), "1"));
    try {
      eval(s);
      return undefined;
    }
    catch (e) {
      return e;
    }
  }

  // Questionaire Text Mappings

  public getAllVarsHintQuestionaire(): string {
    return "Variablen aus den Dialogen:\r\n"+this.getVarsFromDialogs().join(", ") + "\r\n" +
      " und zus. definiert:\r\n" + this.getQuestionaire().vars.map(var1 => var1.name).join(", ");
  }

  public deleteQuestionaireTm(i: number): void {
    this.content.questionaire.textMappings.splice(i, 1);
  }

  public addQuestonaireTm(): void {
    if (this.content.questionaire.textMappings === undefined) {
      this.content.questionaire.textMappings = [];
    }
    this.content.questionaire.textMappings.push({varName: '', values: []});
  }

  public moveQuestionaireTm(i: number, direction: number) {
    const varEntry = this.content.questionaire.textMappings.splice(i, 1);
    this.content.questionaire.textMappings.splice(i+direction, 0, varEntry[0]);
  }

  public tmErrorQuestionaire(i: number) {
    let vars = this.getVarsFromDialogs();
    vars = vars.concat(this.content.questionaire.vars.map(verEntry => verEntry.name));
    let varName = this.content.questionaire.textMappings[i].varName;
    if ( vars.includes(varName) ) {
      return undefined;
    }
    return "'"+varName+"' ist keine definierte Variable";
  }

  public tmSortErrorQuestionaire(i: number) {
    let vars = this.getVarsFromDialogs();
    vars = vars.concat(this.content.questionaire.vars.map(verEntry => verEntry.name));
    let s = this.content.questionaire.textMappings[i].sortValue;
    if ( s === undefined || s === '' ) {
      return undefined;
    }
    vars.forEach(var1 => s = s.replace(new RegExp('\\b' + var1 + '\\b', "g"), "1"));
    try {
      eval(s);
      return undefined;
    }
    catch (e) {
      return e;
    }
  }

  public addQuestonaireTmValue(i: number): void {
    if (this.content.questionaire.textMappings[i].values === undefined) {
      this.content.questionaire.textMappings[i].values = [];
    }
    this.content.questionaire.textMappings[i].values.push({minVal: undefined, maxVal: undefined, text: ''});
  }

  public deleteQuestionaireTmVal(i: number, j: number): void {
    this.content.questionaire.textMappings[i].values.splice(j, 1);
  }

  public resortTm(): void {
    if (this.content.questionaire.textMappings !== undefined) {
      setTimeout(() => this.resortTm1());
    }
  }

  private resortTm1(): void {
      for (let i = 0; i < this.content.questionaire.textMappings.length; i++) {
        if (this.content.questionaire.textMappings[i].values !== undefined) {
          // swap max min, if necessary 
          for (let j = 0; j < this.content.questionaire.textMappings[i].values.length; j++) {
            if (this.content.questionaire.textMappings[i].values[j].maxVal !== undefined && 
              this.content.questionaire.textMappings[i].values[j].minVal !== undefined
            ) {
              console.log( "## "+ i +  " " + j + " " + this.content.questionaire.textMappings[i].values[j].maxVal + " " + this.content.questionaire.textMappings[i].values[j].minVal)
              if ( this.content.questionaire.textMappings[i].values[j].maxVal*1 < 
                this.content.questionaire.textMappings[i].values[j].minVal*1) {
                  console.log( "## swap "+ i +  " " + j)
                  const a = this.content.questionaire.textMappings[i].values[j].minVal;
                  this.content.questionaire.textMappings[i].values[j].minVal = this.content.questionaire.textMappings[i].values[j].maxVal;
                  this.content.questionaire.textMappings[i].values[j].maxVal = a;
              }
            }
          }
          setTimeout(() => this.resortTm2(i));
        }
      }
    }

    private resortTm2(i: number): void {
      // sort by max-value
      this.content.questionaire.textMappings[i].values = this.content.questionaire.textMappings[i].values.sort((v1, v2) => {
        if ( v1.maxVal == undefined ) {
          return 1;
        }
        if ( v2.maxVal == undefined ) {
          return -1;
        }
        return v2.maxVal - v1.maxVal;
      });
    }

    public getDialogsVarNames(dialog: Dialog): string {
      const s = dialog.questions
        .filter(q => (q.varName !== undefined && q.varName !== null))
        .map(q => q.varName)
        .join(', ');
      return s;
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/contents-details.component.ts